<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Testimonial</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/testimonials" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateTestimonial" v-if="testimonial">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="testimonial.author"
                                  label="Author"
                                  placeholder="Enter Testimonial author"
                                  v-validate="rules.author"
                                  data-vv-name="author"
                                  cus-name="author"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="testimonial.designation"
                                  label="Designation"
                                  placeholder="Enter author designation"
                                  v-validate="rules.designation"
                                  data-vv-name="designation"
                                  cus-name="designation"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-3">
                        <fg-input type="text"
                                  v-model="testimonial.location"
                                  label="Location"
                                  placeholder="Enter Location"
                                  v-validate="rules.location"
                                  data-vv-name="location"
                                  cus-name="location"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="testimonial.isActive"
                          label="Status"
                          v-validate="rules.isActive"
                          data-vv-name="isActive"
                          cus-name="isActive"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                      <div class="col-4" v-if="pages.length">
                        <fg-select
                          v-model="testimonial.pageName"
                          label="Page"
                          v-validate="rules.pageName"
                          data-vv-name="pageName"
                          cus-name="pageName"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="pages"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <fg-text-area
                          rows="5"
                          v-model="testimonial.quote"
                          label="Quote"
                          placeholder="Enter Testimonial Quote"
                          v-validate="rules.quote"
                          data-vv-name="quote"
                          cus-name="quote"
                          :has-errors="errors"
                          :is-fields="fields">
                        </fg-text-area>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Testimonial
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditTestimonial',
        created (){
        this.$store.dispatch('GETSELECTEDTESTIMONIAL', this.$route.params.id).then(() =>{
            this.testimonial = this.selectedTestimonial;
        })
    },
    data () {
        let dateTime = new Date();
        return {
            testimonial: this.selectedTestimonial || {},
          rules: {
            author: {required : true},
            designation: {required : false},
            quote: {required : true, max : 200},
            isActive: {required: true},
            pageName: {required: true},
            location: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
          pages: [{name:'Select Page'}, {id:"B2B", name:'B2B'}, {id:"UNAUTH", name:'UNAUTH'}]
        }
    },
    methods: {
        updateTestimonial () {
          console.log("this.testimonial : ", this.testimonial);
          this.$validator.validateAll().then((result) => {
            if(result){

              let updateTestimonial = () =>{
                this.$store.dispatch('UPDATE_TESTIMONIAL', this.testimonial)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Testimonial is successfully updated', 'success', ()=>this.$router.push('/admin/testimonials'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_TESTIMONIAL API error : ", err);
                  })
              };
              updateTestimonial();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'testimonials', `getTestimonial${11}`, 'selectedTestimonial']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Testimonials/EditTestimonial.vue